import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconQuickAi: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconQuickAi"><Path d="M16.1 2.5H14.9L13.4 6.4L9.5 7.9V9.1L13.4 10.6L14.9 14.5H16.1L17.6 10.6L21.5 9.1V7.9L17.6 6.4L16.1 2.5Z" stroke="currentColor"/><Path d="M4 20L11 13" stroke="currentColor"/><Path d="M9 20L12.5 16.5" stroke="currentColor"/><Path d="M4 15L7.5 11.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconQuickAi;
